// extracted by mini-css-extract-plugin
export var closeButtonContainer = "Modal_closeButtonContainer__dOTID";
export var modalContent = "Modal_modalContent__O1Aa3";
export var openBody = "Modal_openBody__Lp9zg";
export var shared = "'../shared.module.css'";
export var sm = "576px";